let language = {
    "LBL_HOME":"Home",
    "LBL_ADMIN": "Admin",
    "LBL_MIS_REPORTS":"MIS Reports",
    "LBL_CATEGORY_REPORT":"Category Report",
    "LBL_PRODUCT_REPORT":"Product Report",
    "LBL_SELECT_CATEGORY":"Select Category",
    "LBL_DATE":"Date",
}

export default language;